export default "__VITE_ASSET__Cqnf4x_u__"